import { render, staticRenderFns } from "./selected-person.vue?vue&type=template&id=933ebe0c"
import script from "./selected-person.vue?vue&type=script&lang=js"
export * from "./selected-person.vue?vue&type=script&lang=js"
import style0 from "./selected-person.vue?vue&type=style&index=0&id=933ebe0c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports